/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Entry, EntryCollection } from "contentful";
import { ContentfulEntryFields } from "../types";
import { FilterOptions } from "../models/FilterOptions";
import { ContentBlock } from "../models/ContentBlock";
import { Metadata } from "../models/Metadata";

const partner = "verizon";
const DEFAULT_PARTNER_KEY = "all";

export const mapEntryItems = (
  items: Entry<ContentfulEntryFields>[],
): Record<string, Entry<ContentfulEntryFields>> | undefined => {
  const entryItemsByIdWithPartner = {} as Record<
    string,
    Record<string, Entry<ContentfulEntryFields>>
  >;
  try {
    items.forEach(item => {
      if (
        item.fields.id === "__proto__" ||
        item.fields.partner === "__proto__"
      ) {
        throw new Error("attempted prototype pollution");
      }
      if (typeof entryItemsByIdWithPartner[item.fields.id] === "undefined") {
        entryItemsByIdWithPartner[item.fields.id] = {};
      }
      entryItemsByIdWithPartner[item.fields.id][item.fields.partner] = item;
    });
  } catch (e) {
    console.log(e);
    return;
  }

  const entryItemsById = [{}];
  Object.keys(entryItemsByIdWithPartner).map(key => {
    // @ts-ignore
    entryItemsById[key] =
      typeof entryItemsByIdWithPartner[key][partner] !== "undefined"
        ? entryItemsByIdWithPartner[key][partner]
        : entryItemsByIdWithPartner[key][DEFAULT_PARTNER_KEY];
  });

  // @ts-ignore
  return entryItemsById;
};

export const containsSubset = (arr1: string[], arr2: string[]): boolean => {
  const lowercase1 = arr1.map(item => item.toLowerCase());
  const lowercase2 = arr2.map(item => item.toLowerCase());

  return lowercase2.every(
    item => lowercase1.includes("all") || lowercase1.includes(item),
  );
};
// arr2.every(item => arr1.includes("all") || arr1.includes(item));

//arr1 = [all]
//arr1 = [android, samsung]

//arr2 = [all]
//arr2 = [samsung]

//if arr1 contains all => then we take the item
//if arr1.includes(arr2) => then we take the item

//arr2.every(item => arr1.includes(item) || arr1.includes("all"));

export const filterEntries = (
  entries: EntryCollection<ContentBlock & Metadata>,
  filterOptions: FilterOptions,
): Entry<ContentBlock & Metadata>[] =>
  entries.items.filter(
    item =>
      item.fields.contentType &&
      containsSubset(
        item.fields.newDeviceType,
        filterOptions.newPhoneAllowed.filter(filter => filter.toLowerCase()),
      ) &&
      containsSubset(
        item.fields.oldDeviceType.filter(filter => filter.toLowerCase()),
        filterOptions.oldPhoneAllowed.filter(filter => filter.toLowerCase()),
      ) &&
      containsSubset(
        item.fields.flowType.filter(filter => filter.toLowerCase()),
        filterOptions.flowTypesAllowed.filter(filter => filter.toLowerCase()),
      ) &&
      containsSubset(
        item.fields.oldDeviceStatus.filter(filter => filter.toLowerCase()),
        filterOptions.oldDeviceStatus.filter(filter => filter.toLowerCase()),
      ),
  );
